import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const simulatorSvg = (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="11" y="29" width="26" height="8" rx="3" stroke="currentColor" strokeLinejoin="round" />
        <path d="M20.5 29a3.5 3.5 0 0 1 7 0M24 29V17" stroke="currentColor" strokeLinecap="round" />
        <circle cx="24" cy="12.5" r="4.5" stroke="currentColor" />
        <circle cx="31.5" cy="33" r="1.5" stroke="currentColor" />
    </svg>
)

const SimulatorIcon: React.FC<SvgIconProps> = (props) => <SvgIcon {...props}>{simulatorSvg}</SvgIcon>

export default SimulatorIcon
